import { Component } from "@angular/core";

@Component({
    selector: 'm4u-loading-animation',
    templateUrl: './loading-animation.component.html',
    styleUrls: ['./loading-animation.component.scss']
})
export class M4ULoadingAnimationComponent {
    constructor() { }
}